import { render, staticRenderFns } from "./DeletePostAddressDialog.vue?vue&type=template&id=491979e3&"
import script from "./DeletePostAddressDialog.vue?vue&type=script&lang=js&"
export * from "./DeletePostAddressDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports